import { useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { StyleSheet, View } from 'react-native'
import { useStore } from '../../../models'

import ChipBlueGreen from '../assets/ChipsBlueGreen.svg'
import ChipOrangePurple from '../assets/ChipsOrangePurple.svg'
import ChipPinkMaroon from '../assets/ChipsPinkMaroon.svg'
import ChipIcon from '../assets/Chip.svg'
import { useResponsive } from '@/screens/new-design/hooks'
import { SvgProps } from 'react-native-svg'
import { Chips } from '../../GameAssets/Chips'

export const ChipsLayout = observer(() => {
  const {
    game: { setPotChipsPosition }
  } = useStore()
  const viewRef = useRef<View>(null)

  const { verticalScale } = useResponsive()
  const size = verticalScale(24)

  return (
    <View
      ref={viewRef}
      onLayout={(e) => {
        if (viewRef.current) {
          viewRef.current.measure((x, y, width, height, pageX, pageY) => {
            setPotChipsPosition({ x: pageX, y: pageY })
          })
        }
      }}
    >
      <ChipsPot size={size} />
    </View>
  )
})

export const ChipsPotSimple = ({ size }: { size: number }) => {
  return (
    <View>
      <Chips.Pink
        height={size}
        width={size}
        style={{
          position: 'absolute',
          top: -(size * 0.5),
          left: size * 0.5
        }}
      />
      <View style={{ flexDirection: 'row' }}>
        <Chips.Blue height={size} width={size} style={{ right: -2 }} />
        <Chips.Orange height={size} width={size} style={{ left: -2 }} />
      </View>
    </View>
  )
}

export const ChipsPot = ({ size }: { size: number }) => {
  return (
    <View style={styles.container}>
      <View style={{ position: 'absolute', top: -(size * 0.5) + 2 }}>
        <Chips.Pink height={size} width={size} />
      </View>
      <View style={styles.bottom}>
        <View style={{ right: -2 }}>
          <Chips.Blue height={size} width={size} />
        </View>
        <View style={{ left: -2 }}>
          <Chips.Orange height={size} width={size} />
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10
  },
  bottom: {
    flexDirection: 'row'
  }
})
